export default "__VITE_ASSET__Ba3KN2mX__"